export default {"src":"/_next/static/media/icon-level-5.f8dae4a8.svg","height":25,"width":52};